import(/* webpackChunkName: "navigationMobile" */ 'Feature/LotteryNavigation/code/Styles/Mobile/navigationMobile.scss');

window.am = window.am || {};

window.am.mobileLotteryNavigation = new function () {
    var that = this;
    var desktopWidth = 1024;

    this.init = function () {
        if (document.querySelector(".lottery-nav-mobile") == null) {
            return;
        }

        this.appendMetaRightLotteryNavigations();

        var navButtonOpen = document.querySelector(".lottery-nav-mobile-open");
        var navButtonClose = document.querySelector(".lottery-nav-mobile-header-close");
        var parentMenuItems = document.querySelectorAll('.lottery-nav-mobile-level-item[data-has-children="true"] > a');
        var menuHeaderItems = document.querySelectorAll(".lottery-nav-mobile-header-level-item > a");
        navButtonOpen.addEventListener("click", that.onOpenClick);
        navButtonClose.addEventListener("click", that.onCloseClick);
        window.addEventListener("resize", that.onResize);

        parentMenuItems.forEach(function (node) {
            node.addEventListener("click", that.onMenuParentItemClick);
        });

        menuHeaderItems.forEach(function (node) {
            node.addEventListener("click", that.onMenuHeaderItemClick);
        });

        that.resetToActiveLevel();
        that.setAnchorsAccessibility();
    };

    /**
       * Show full width mobile menu
       */
    this.onOpenClick = function () {
        var navMobile = document.querySelector(".lottery-nav-mobile");
        var navMobileHeader = document.querySelector(".lottery-nav-mobile-header");
        var closeButton = document.querySelector(".lottery-nav-mobile-header-close");

        window.scrollTo(0, 0);
        navMobile.classList.add("lottery-nav-mobile--visible");
        navMobileHeader.classList.add("lottery-nav-mobile-header--visible");
        document.querySelector("body").style.overflow = "hidden";
        closeButton.querySelector("button").classList.add("js-hiraku-offcanvas-btn-active");
    };

    /**
       * Close full width mobile menu
       */
    this.onCloseClick = function () {
        var navMobile = document.querySelector(".lottery-nav-mobile");
        var navMobileHeader = document.querySelector(".lottery-nav-mobile-header");
        var closeButton = document.querySelector(".lottery-nav-mobile-header-close");

        navMobile.classList.remove("lottery-nav-mobile--visible");
        navMobileHeader.classList.remove("lottery-nav-mobile-header--visible");
        document.querySelector("body").style.overflow = "auto";
        closeButton.querySelector("button").classList.remove("js-hiraku-offcanvas-btn-active");

        setTimeout(function () {
            that.resetToActiveLevel();
        },
            420);
    };

    /**
       * Click handler for menu item
       * @param {any} event
       */
    this.onMenuParentItemClick = function (event) {
        event.stopPropagation();
        event.stopImmediatePropagation();
        event.preventDefault();
        var menuElement = document.querySelector('.lottery-nav-mobile-level[data-id="' + this.parentElement.dataset.id + '"]');
        that.showMenuLevel(menuElement);
    };

    /**
       * Click handler for Header menu item
       * @param {any} event
       */
    this.onMenuHeaderItemClick = function (event) {
        event.stopPropagation();
        event.stopImmediatePropagation();
        event.preventDefault();

        // Get correct target menu level, default is root
        var menuElement = document.querySelector('.lottery-nav-mobile-level[data-id="' + this.parentElement.dataset.id + '"]')
            || document.querySelector('.lottery-nav-mobile-level[data-id="00000000-0000-0000-0000-000000000000"]');

        // Pre remove visible modifier, for correct animation direction
        document.querySelectorAll(".lottery-nav-mobile-level--visible").forEach(function (currentElement) {
            currentElement.classList.remove("lottery-nav-mobile-level--visible");
        });

        // Pre remove visible modifier, for correct animation direction
        document.querySelectorAll(".lottery-nav-mobile-header-level--visible").forEach(function (currentElement) {
            currentElement.classList.remove("lottery-nav-mobile-header-level--visible");
        });

        that.showMenuLevel(menuElement);
    };

    /**
       * Hide LotteryNavigation on desktop size
       */
    this.onResize = function () {
        var navMobile = document.querySelector(".lottery-nav-mobile");

        if (window.innerWidth >= desktopWidth && navMobile.classList.contains("lottery-nav-mobile--visible")) {
            that.onCloseClick();
        }

        that.setAnchorsAccessibility();
    };

    /**
       * Disables anchors accessibility for desktop and enables it on mobile
       */
    this.setAnchorsAccessibility = function () {
        var anchors = document.querySelectorAll(".lottery-nav-mobile-header a, .lottery-nav-mobile a");
        if (window.innerWidth >= desktopWidth) {
            anchors.forEach(function (element) {
                element.setAttribute("tabindex", "-1");
                element.setAttribute("aria-hidden", "true");
            });
        } else {
            anchors.forEach(function (element) {
                element.removeAttribute("tabindex");
                element.removeAttribute("aria-hidden");
            });
        }
    };

    /**
       * Resets all levels to the active one or default the root level menu
       */
    this.resetToActiveLevel = function () {
        var rootElement = document.querySelector('.lottery-nav-mobile-level[data-id="00000000-0000-0000-0000-000000000000"]');
        var activeMenuItem = document.querySelector(".lottery-nav-mobile-level-item--active");

        // Remove all modifiers for initial state
        document.querySelectorAll(".lottery-nav-mobile-level--visible, .lottery-nav-mobile-level--hidden").forEach(function (currentElement) {
            currentElement.classList.remove("lottery-nav-mobile-level--visible");
            currentElement.classList.remove("lottery-nav-mobile-level--hidden");
        });
        document.querySelectorAll(".lottery-nav-mobile-header-level--visible, .lottery-nav-mobile-header-level--hidden").forEach(function (currentElement) {
            currentElement.classList.remove("lottery-nav-mobile-header-level--visible");
            currentElement.classList.remove("lottery-nav-mobile-header-level--hidden");
        });

        if (activeMenuItem) {
            // Pre hide all parents
            var parent = document.querySelector('.lottery-nav-mobile-level[data-id="' + activeMenuItem.dataset.parentId + '"]');
            rootElement.classList.add("lottery-nav-mobile-level--hidden");

            while (parent) {
                // Also reset header
                var parentHeader = document.querySelector('.lottery-nav-mobile-header-level[data-id="' + parent.dataset.id + '"]');
                if (parentHeader) {
                    parentHeader.classList.add("lottery-nav-mobile-header-level--hidden");
                }

                parent.classList.add("lottery-nav-mobile-level--hidden");
                parent = document.querySelector('.lottery-nav-mobile-level[data-id="' + parent.dataset.parentId + '"]');
            }

            // Actually reset to active menu item
            that.showMenuLevel(activeMenuItem.parentElement);
        } else {
            // Default is root menu
            rootElement.classList.add("lottery-nav-mobile-level--visible");
            that.showMenuLevel(rootElement);
        }
    };

    /**
       * Shows the specific menu level element
       * @param {any} menuElementToShow
       */
    this.showMenuLevel = function (menuElementToShow) {
        // Pre hide all current visible
        document.querySelectorAll(".lottery-nav-mobile-level--visible").forEach(function (currentElement) {
            currentElement.classList.add("lottery-nav-mobile-level--hidden");
        });

        // Append meta LotteryNavigations
        that.appendMetaLotteryNavigations(menuElementToShow);

        // slide new menu level in
        menuElementToShow.scrollTop = 0;
        menuElementToShow.classList.remove("lottery-nav-mobile-level--hidden");
        menuElementToShow.classList.add("lottery-nav-mobile-level--visible");

        // set header menu level
        var headerElement = document.querySelector('.lottery-nav-mobile-header-level[data-id="' + menuElementToShow.dataset.id + '"]');
        that.showMenuHeaderLevel(headerElement);
    };

    /**
       * Shows the specific menu header level element
       * @param {any} headerElementToShow
       */
    this.showMenuHeaderLevel = function (headerElementToShow) {
        // Pre hide all current visible
        document.querySelectorAll(".lottery-nav-mobile-header-level--visible").forEach(function (currentElement) {
            currentElement.classList.add("lottery-nav-mobile-header-level--hidden");
        });

        // slide new header in
        headerElementToShow.classList.remove("lottery-nav-mobile-header-level--hidden");
        headerElementToShow.classList.add("lottery-nav-mobile-header-level--visible");

        // Show logo, if root menu is reached
        var headerContentElement = document.querySelector(".lottery-nav-mobile-header-content");

        if (headerElementToShow.dataset.id === "00000000-0000-0000-0000-000000000000") {
            headerContentElement.classList.remove("lottery-nav-mobile-header-content--visible");
        } else {
            headerContentElement.classList.add("lottery-nav-mobile-header-content--visible");
        }
    };

    this.appendMetaLotteryNavigations = function (menuElement) {
        if (menuElement.dataset.hasMetaLotteryNavigationItems === "true") {
            return;
        }

        var itemTemplates = document.querySelectorAll(".lottery-nav-mobile-meta-template > .lottery-nav-mobile-meta > .lottery-nav-mobile-meta-item");
        itemTemplates.forEach(function (currentItemTemplate) {
            menuElement.appendChild(currentItemTemplate.cloneNode(true));
        });

        menuElement.dataset.hasMetaLotteryNavigationItems = true;
    };

    this.appendMetaRightLotteryNavigations = function () {
        var menuElement = document.querySelector(".lottery-nav-mobile-content > .lottery-nav-mobile-level");
        var itemTemplates = document.querySelectorAll(".lottery-nav-mobile-meta-right > .lottery-nav-mobile-level-item");
        itemTemplates.forEach(function (currentItemTemplate) {
            menuElement.appendChild(currentItemTemplate.cloneNode(true));
        });

        var itemChildTemplates = document.querySelectorAll(".lottery-nav-mobile-meta-right .lottery-nav-mobile-level");
        itemChildTemplates.forEach(function (currentItemChildTemplate) {
            menuElement.parentNode.appendChild(currentItemChildTemplate.cloneNode(true));
        });

        var menuHeaderElement = document.querySelector(".lottery-nav-mobile-header-content");
        var headerTemplates = document.querySelectorAll(".lottery-nav-mobile-meta-right .lottery-nav-mobile-header-level");
        headerTemplates.forEach(function (currentHeaderTemplate) {
            menuHeaderElement.appendChild(currentHeaderTemplate.cloneNode(true));
        });
        //

        // Need to remove the original html markup because of the doubled id
        // and the original markup is no longer used.
        var mobileSwitchLotteryNavigation = document.querySelector(".lottery-nav-mobile-meta-template .lottery-nav-mobile-meta-right");
        if (mobileSwitchLotteryNavigation != null) {
            mobileSwitchLotteryNavigation.parentElement.remove();
        }
    };
};

window.addEventListener("load", () => {
    window.am.mobileLotteryNavigation.init();
});